// MAINTENANCE: Delete this entire file if it is not needed when maintenance is complete
// ============================================
// MAINTENANCE CONFIGURATION
// ============================================

/* 
The maintenance alerts are not used anymore search for MAINTENANCE tag 
to find all maintenance-related files and delete the files or lines of code.
*/

import { t } from 'i18next'
import moment from 'moment-timezone'

export const TIMEZONE = 'Europe/Amsterdam'
export const MAINTENANCE_START = moment.tz('2026-01-16T16:30:00', TIMEZONE) // When maintenance begins
export const MAINTENANCE_END = moment.tz('2026-01-18T23:59:00', TIMEZONE) // When maintenance ends

// Helper functions to generate time text
export const getMaintenanceWindowText = () => {
	return `${t('app:Maintenance.maintenanceWindow', { start: MAINTENANCE_START.format('D MMMM YYYY HH:mm'), end: MAINTENANCE_END.format('D MMMM HH:mm') })}`
}

export const getExpectedCompletionText = () => {
	return `${t('app:Maintenance.expectedCompletion', { end: MAINTENANCE_END.format('D MMMM YYYY HH:mm') })}`
}
